/* unplugin-vue-components disabled */import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9b3a917e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "menus"
};
const _hoisted_2 = ["onClick"];
export default /*#__PURE__*/_defineComponent({
  __name: 'menus',
  props: {
    menus: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    // const route = useRoute();
    const router = useRouter();
    const activePath = computed(() => {
      return router.currentRoute.value.path;
    });
    const handleChange = item => {
      router.push(item.path);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [__props.menus.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menus, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.path,
          class: _normalizeClass(['menu', _unref(activePath) === item.path ? 'active' : '']),
          onClick: $event => handleChange(item)
        }, [_createElementVNode("span", null, _toDisplayString(item.meta.title), 1)], 10, _hoisted_2);
      }), 128))])) : _createCommentVNode("", true)]);
    };
  }
});